import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    'otp',
    'currentPassword',
    'otpBtn',
    'currentPasswordBtn',
    'credentialChooser',
    'errors',
  ]
  static values = {
    methods: {type: Array, default: []},
    method: {type: String, default: ''},
    errors: {type: Array, default: []},
  }

  connect() {
  }

  async submit() {
    this.dispatch('submit')
  }

  async authHeaders() {
    const headers = {}
    if(this.methodValue === 'otp') {
      headers['X-Authentication-Method'] = 'otp'
      headers['X-Authentication-Value'] = this.otpTarget.value
    } else if(this.methodValue === 'current_password') {
      headers['X-Authentication-Method'] = 'current_password'
      headers['X-Authentication-Value'] = this.currentPasswordTarget.value
    }
    return headers
  }

  methodsValueChanged() {    
    if(this.methodsValue.length > 1) {
      this.credentialChooserTarget.classList.remove('hide')
      this.#disableButton(this.otpBtnTarget)
      this.#disableButton(this.currentPasswordBtnTarget)
      if(this.methodsValue.includes('otp')) {
        this.#enableButton(this.otpBtnTarget)
      }
      if(this.methodsValue.includes('current_password')) {
        this.#enableButton(this.currentPasswordBtnTarget)
      }
    } else {
      this.credentialChooserTarget.classList.add('hide')
    }
    this.methodValueChanged()
  }

  methodValueChanged() {
    let method = this.methodValue
    if(!this.methodsValue.includes(method)) {
      method = this.methodsValue[0]
    }
    
    this.showNone()
    if(method === 'otp') {
      this.showOTP()
    } else if(method === 'current_password') {
      this.showCurrentPassword()
    }
  }

  errorsValueChanged() {
    this.#setErrors(this.errorsValue)
  }

  showNone() {
    this.otpTarget.parentElement.parentElement.classList.add('hide')
    this.otpTarget.setAttribute('disabled', 'disabled')

    this.currentPasswordTarget.parentElement.parentElement.classList.add('hide')
    this.currentPasswordTarget.setAttribute('disabled', 'disabled')
  }

  showOTP() {
    this.methodValue = 'otp'
    this.#activateButton(this.otpBtnTarget)
    this.#deactivateButton(this.currentPasswordBtnTarget)

    this.otpTarget.parentElement.parentElement.classList.remove('hide')
    this.otpTarget.removeAttribute('disabled')
    
    this.currentPasswordTarget.parentElement.parentElement.classList.add('hide')
    this.currentPasswordTarget.setAttribute('disabled', 'disabled')
    this.otpTarget.focus()
    window.setTimeout(() => {
      this.otpTarget.focus()
    }, 500)
  }

  showCurrentPassword() {
    this.methodValue = 'current_password'
    this.#activateButton(this.currentPasswordBtnTarget)
    this.#deactivateButton(this.otpBtnTarget)

    this.otpTarget.parentElement.parentElement.classList.add('hide')
    this.otpTarget.setAttribute('disabled', 'disabled')

    this.currentPasswordTarget.parentElement.parentElement.classList.remove('hide')
    this.currentPasswordTarget.removeAttribute('disabled')
    this.currentPasswordTarget.focus()

    window.setTimeout(() => {
      this.currentPasswordTarget.focus()
    }, 500)
  }

  #activateButton(button) {
    button.classList.remove('primary')
    button.classList.add('secondary')
  }

  #deactivateButton(button) { 
    button.classList.remove('secondary')
    button.classList.add('primary')
  }

  #enableButton(button) {
    button.classList.remove('hide')
    button.classList.remove('disabled')
    button.removeAttribute('disabled')
  }

  #disableButton(button) {
    button.classList.add('hide')
    button.classList.add('disabled')
    button.setAttribute('disabled', 'disabled')
  }

  #setErrors(errors) {
    if(errors.length > 0) {
      this.errorsTarget.classList.remove('hide')
      this.errorsTarget.innerHTML = errors.join('<br>')
    } else {
      this.#clearErrors()
    }
  }

  #clearErrors() {
    this.errorsTarget.classList.add('hide')
    this.errorsTarget.innerHTML = ''
  }
}
